import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import "./alert.css";

// Alerta con el estilo de Casvi. status: "success" | "error" | "warning" | "info"
export const showAlert = ({ status, title, text, confirmText }) => {
  return Swal.fire({
    icon: status,
    title,
    text,
    confirmButtonText: confirmText,
    buttonsStyling: false,
    backdrop: true,
    showClass: { popup: "casvi-alert-show" },
    hideClass: { popup: "casvi-alert-hide" },
    customClass: {
      container: "casvi-alert-container",
      popup: `casvi-alert casvi-alert-${status}`,
      icon: "casvi-alert-icon",
      title: "casvi-alert-title",
      htmlContainer: "casvi-alert-text",
      actions: "casvi-alert-actions",
      confirmButton: "casvi-alert-confirm",
    },
  });
};
